import { Injectable } from '@angular/core';

import { ChangePasswordDTO, RidangoReduxAction } from '@ridango/core';
import { Action } from 'redux';

export interface PasswordChangeActions extends Action {
    type: string;
    payload?: any;
}

@Injectable()
export class ChangePasswordActions {
    static readonly GET_NEW_PASSWORD = '[Change-Password]: Get new password';
    static readonly SET_NEW_PASSWORD = '[Change-Password]: Set new password';
    static readonly SET_NEW_PASSWORD_SUCCESS = '[Change-Password]: Set new password successful';
    static readonly SET_NEW_PASSWORD_FAILED = '[Change-Password]: Set new password failed';

    getNewPassword(): PasswordChangeActions {
        return {
            type: ChangePasswordActions.GET_NEW_PASSWORD
        };
    }

    setNewPassword(payload: ChangePasswordDTO): RidangoReduxAction<ChangePasswordDTO> {
        return {
            type: ChangePasswordActions.SET_NEW_PASSWORD,
            payload: payload
        };
    }

    setNewPasswordSuccess(payload: any): RidangoReduxAction {
        return {
            type: ChangePasswordActions.SET_NEW_PASSWORD_SUCCESS,
            payload: payload
        };
    }

    setNewPasswordFailed(error: any): RidangoReduxAction {
        return {
            type: ChangePasswordActions.SET_NEW_PASSWORD_FAILED,
            payload: error
        };
    }
}
